const genderMap = {
    1: 'Male',
    2: 'Female',
    3: 'Others',
    '': 'Select'
};

const defaultSelect = (value) => value || 'Select';

const userInputData = (apiData, inputFields) => {
    const fieldMap = {
        'First Name': 'first_name',
        'Last Name': 'last_name',
        'Email Address': 'email',
        'Alternate Email Address (Optional)': 'user_details__alter_email',
        'Short Name': 'short_name',
        'Date of Birth': 'date_of_birth',
        'City': 'user_details__city',
        'Marital Status': 'user_details__marital_status',
        'Country': 'country__country_name',
        'Gender': (data) => genderMap[data.gender] || 'Select',
        'occupation': 'user_details__occupation',
        'Company Name': 'company_name',
        'Industry': 'user_details__industry__demographic_name',
        'Designation': 'user_details__designation',
        'Qualification': 'user_details__qualification__demographic_name',
        'Work Experience (In Years)': 'user_details__work_experience',
        'Tenure in Company (In Years)': 'user_details__tenure_in_company'
    };

    const field = fieldMap[inputFields.formLabel];
    if (typeof field === 'function') {
        return field(apiData);
    }
    return defaultSelect(apiData && apiData[field]);
};

export { userInputData };


// WEBPACK FOOTER //
// ./src/new/Utils/user-profile-data.js